import { ModifiersInterface, PriceInterface } from "@/interface/business/item.interface";
import { PriceMoney } from "@/modules/location";
import { ModifiersType } from "@/types/business/item.type";
import { Pricing } from "@/modules/ooc/pricing";
import { NAME_LOCAL_NAME_KEY } from "@/enums/orders.enum";
import store from "@/store";

/**
 * Modifier Class
 * @param {ModifiersType} Modifier
 */
export class Modifier implements ModifiersInterface {
  id: string;
  unique?: number = 0;
  name: string;
  local_name: string;
  order: number;
  cost: number;
  quantity: number;
  original_name?: string = "";
  original_local_name?: string = "";
  plu?: string = "";
  pricing: any;
  selected?: boolean = false;
  price_money: PriceInterface = new PriceMoney({ amount: 0 });
  price?: any;
  sorting?: any;

  constructor(data: ModifiersType) {
    this.id = data.id || "";
    this.name = data.name || "";
    this.local_name = data.local_name || "";
    this.original_name = data.original_name ?? data.name ?? "";
    this.original_local_name = data.original_local_name ?? data.local_name ?? "";
    this.order = data.order || 0;
    this.cost = data.cost || 0;
    this.quantity = data.quantity || 0;
    this.selected = data.selected || false;
    this.pricing = new Pricing(data.pricing) || "";
    this.plu = data.plu || "";
    this.price = data?.price || 0;
    this.sorting = data?.sorting;
    this.order = data?.order;
    this.setupPriceMoney(data);
  }

  /**
   * To setup price
   * return {void}
   */
  public setupPriceMoney(data): void {
    let priceMoney = data.price_money;

    // price money from sale object
    if (data?.price) {
      priceMoney = {
        amount: data?.price,
      };
    }

    this.price_money = new PriceMoney(priceMoney);
  }

  /**
   * To increase quantity
   * return {void}
   */
  public increase(): void {
    this.quantity++;
  }

  /**
   * To decrease quantity
   * return {void}
   */
  public decrease(): void {
    this.quantity--;
  }

  /**
   * Select Modifier
   * @return {void}
   */
  public select(): void {
    this.selected = true;
  }

  /**
   * UnSelect Modifier
   * @return {void}
   */
  public unSelect(): void {
    this.selected = false;
  }

  /**
   * check If Staged
   * @param stagedModifiers
   */
  public checkIsStaged(stagedModifiers: Array<ModifiersType>): boolean {
    return !!stagedModifiers.find((item) => item.original_name === this.original_name);
  }

  /**
   * get modifier name by language key
   * @return {string}
   */
  public getDisplayName(): string {
    const { state } = <any>store;
    return this?.[NAME_LOCAL_NAME_KEY[state.App.lang]] || this.name;
  }
}
